import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2773">
      <div className="dark" data-id="element-2774">
        <Hero data-id="element-2775" />
      </div>
      <WhyUs data-id="element-2776" />
      <ByTheNumbers data-id="element-2777" />
      <Services data-id="element-2778" />
      <HowItWorks data-id="element-2779" />
      <FAQ data-id="element-2780" />
      <Reviews data-id="element-2781" />
      <CtaBanner data-id="element-2782" />
    </main>;
}